module.exports = __webpack_public_path__ + "img/3.36c6cf28.png";